<template>
  <div
    class="login"
    v-loading.fullscreen="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="iconfont icon-jiazai"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="login-content">
      <h1 class="font-super">杭州市萧山区历史建筑展示平台</h1>
      <div class="login-from">
        <div class="login-from_input">
          <span class="font-labelheavy">编号</span>
          <input
            type="text"
            placeholder="请输入编号"
            v-model="userNumber"
            :class="{ inputChange: userNumber }"
            v-on:blur="onChange"
          />
        </div>
        <span class="login-tip" v-if="formatTip">账号格式不正确</span>
        <span class="login-tip" v-if="userTip">用户不存在</span>
        <div class="login-from_input">
          <span class="font-labelheavy">密码</span>
          <input
            v-on:keyup.enter="login({ password, userNumber })"
            type="password"
            placeholder="请输入密码"
            v-model="password"
            :class="{ inputChange: password }"
          />
        </div>
        <span class="login-tip" v-if="passwordTip">密码错误</span>
        <el-button
          @click="login({ password, userNumber })"
          class="login-from_submit large"
          :class="{ submitChange: userNumber && password }"
          >立即登录</el-button
        >
        <!-- <div class="login-from_toYun">
          <a href="https://wenhuayun.nanhai.gov.cn/" target="_blank"
            >前往萧山文化云平台</a
          >
        </div> -->
        <router-link :to="{ name: 'Map' }">
          <div class="login-from_toMap">
            进入地图
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '../api/index';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { regEpxUserNumberInt } from '../config/regEpx';
export default {
  name: 'Login',
  computed: {
    ...mapGetters('login', ['userInfo', 'isMobile'])
  },
  data() {
    return {
      userNumber: '',
      password: '',
      loading: false,
      formatTip: false,
      userTip: false,
      passwordTip: false
    };
  },
  methods: {
    ...mapActions('login', ['changeUserInfo', 'changeAuthorizationLimit']),
    ...mapMutations('login', ['setMinioOption']),
    /**
     * 登录回调
     */
    async login({ userNumber, password }) {
      if (userNumber && password) {
        this.formatTip = regEpxUserNumberInt(this.userNumber);
        if (!this.formatTip) {
          this.loading = true;

          await login({ password, userNumber })
            .then(res => {
              if (res.data.code == -1) {
                this.passwordTip = true;
                this.loading = false;
                this.userTip = false;
              } else if (res.data.code == 404) {
                this.userTip = true;
                this.loading = false;
                this.passwordTip = false;
              } else if (res.data.code == 200) {
                const { data } = res.data;
                const { message } = res.data;
                const roleList = data.userUserRoleList;
                const roleTypes = [];

                roleList.forEach(e => {
                  roleTypes.push(e.roleType);
                });
                this.changeAuthorizationLimit(roleTypes);
                this.changeUserInfo({
                  id: data.id,
                  nickName: data.nickName,
                  password: data.password,
                  uid: data.uid,
                  userNumber: data.userNumber,
                  userNumberInt: data.userNumberInt,
                  userUserRoleList: data.userUserRoleList
                });
                this.loading = false;
                this.userTip = false;
                this.passwordTip = false;
                if (this.isMobile) {
                  this.$router.push({ name: 'Map' });
                } else {
                  this.$router.push({ name: 'Relic' });
                }
              }
            })
            .catch(err => {
              this.loading = false;
              this.userTip = true;
            });
        }
      }
    },
    /**
     * 检验登录密码回调
     */
    onChange() {
      this.userNumber = this.userNumber.trim();
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  &-content {
    // width: 388px;
    height: 388px;
  }
  & h1 {
    margin-bottom: 57px;
    height: 72px;
    line-height: 72px;
    text-align: center;
    color: $color-label;
  }
  &-from {
    width: 244px;
    height: 188px;
    margin: 0 auto;
    position: relative;
    &_input {
      margin: 0 auto;
      width: 244px;
    }
    &_input input {
      border: none;
      outline: medium;
      border-bottom: 1px solid $color-primary-light;
      font-size: 13px;
      color: $color-info;
      margin: 13px 0;
      box-shadow: 0 0 0px 1000px white inset;
    }
    &_input span {
      margin-right: 24px;
      color: $color-primary;
      letter-spacing: 10px;
    }
    &_submit {
      width: 244px;
      margin-top: 19px;
      background-color: $color-disabled;
      color: #fff;
    }
    &_toMap {
      margin-top: 25px;
      text-align: right;
      font-size: 13px;
      border-bottom: 1px solid $color-primary;
      position: absolute;
      right: 0;
      color: $color-primary-light;
      cursor: pointer;
    }
    &_toYun {
      margin-top: 25px;
      text-align: left;
      font-size: 13px;
      border-bottom: 1px solid $color-primary;
      position: absolute;
      left: 0;
      color: $color-primary-light;
      cursor: pointer;
      a {
        color: $color-primary-light;
      }
    }
  }
  .login-tip {
    margin-left: 75px;
    font-size: 5px !important;
    color: red;
  }
  .submitChange {
    background-color: $color-primary;
  }
  .inputChange {
    color: $color-label !important;
  }
}
</style>
